import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'lead-details-subtitle',
  templateUrl: './lead-details-subtitle.component.html',
  styleUrls: ['./lead-details-subtitle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeadDetailsSubtitleComponent {
  maxTravelersCount = 4;

  @Input() travelers: number | undefined;
  @Input() from: string | undefined;
  @Input() departDate?: string | null;
  @Input() returnDate?: string | null;
  @Input() showTripRequestLabel = false;
}
